import React from 'react';
import alert from '@assets/images/icons/alert.svg';
import build from '@assets/images/icons/build.svg';
import backtest from '@assets/images/icons/backtest.svg';
import systemResults from '@assets/images/screenshots/system-results.png';

export const SystemsFeature = () => {
    const steps = [
        {
            icon: build,
            title: '01. Build',
            description: 'Simply name your system, add the criteria you want to look at, and choose a bet to backtest against.'
        },
        {
            icon: backtest,
            title: '02. Backtest',
            description: 'See how your system has held up historically. We give you the win percentage, return on investment, record, and breakdown year over year.'
        },
        {
            icon: alert,
            title: '03. Tail',
            description: 'We\'ll notify you when a game matches one of your systems, and show you which books are offering the best lines.'
        }
    ];

    return (
        <div className="bg-white dark:bg-brand-dark-900 mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8">
            <div className="mx-auto max-w-2xl text-center">
                <h2 className="text-base/7 font-semibold text-brand-red-500 dark:text-brand-red-400">Take It Further</h2>
                <p className="mt-2 text-4xl font-semibold tracking-tight text-gray-900 dark:text-white sm:text-5xl sm:text-balance">
                    Automate Your Strategy
                </p>
                <p className="mt-6 text-lg/8 text-gray-600 dark:text-gray-400">
                    Use these insights to build automated betting systems. Create custom criteria, backtest historical performance, 
                    and get notified when games match your winning strategies.
                </p>
            </div>
            
            <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:mt-20 sm:grid-cols-2 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
                {steps.map((step, index) => (
                    <div key={index} className="flex flex-col h-full">
                        <div className="rounded-2xl bg-gray-50 p-6 ring-1 ring-inset ring-gray-200 dark:bg-gray-800 dark:ring-gray-700 h-full flex flex-col">
                            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-red-500 shrink-0">
                                <img src={step.icon} alt="" className="h-6 w-6" />
                            </div>
                            <h3 className="mt-6 text-lg font-semibold leading-8 tracking-tight text-gray-900 dark:text-white">
                                {step.title}
                            </h3>
                            <p className="mt-2 text-base leading-7 text-gray-600 dark:text-gray-400 flex-grow">
                                {step.description}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
            
            {/* System Results section */}
            <div className="relative bg-brand-dark-900 rounded-3xl mt-6">
                <div className="mx-auto max-w-[95vw] sm:max-w-7xl px-2 sm:px-6 py-4 sm:py-12 lg:px-8">
                    <div className="relative overflow-hidden rounded-2xl sm:rounded-3xl">
                        <img 
                            src={systemResults} 
                            alt="Line Leaders System Results" 
                            className="w-full h-auto rounded-2xl sm:rounded-3xl shadow-2xl ring-1 ring-white/10 dark:ring-2 dark:ring-gray-600/30 dark:shadow-[0_0_30px_rgba(255,255,255,0.1)]"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
